import React from "react";

const WorkOrderPrintLayout = ({
  workOrderDetails,
  comments,
  selectedAssignee,
  selectedPriority,
  workOrderTypes,
  workOrderSubtypes,
  workOrderLocations,
  selectedTypeId,
  selectedSubtypeId,
  selectedLocationId,
  member,
  attachedFiles = [],
  apiBaseUrl = "",
}) => {
  const type = workOrderTypes?.find((t) => t.id === selectedTypeId)?.type || "N/A";
  const subtype = workOrderSubtypes?.find((s) => s.id === selectedSubtypeId)?.subtype_name || "N/A";
  const location = workOrderLocations?.find((l) => l.id === selectedLocationId)?.location_name || "N/A";

  const imageFiles = attachedFiles.filter(
    (f) => f.file_type && f.file_type.startsWith("image/")
  );

  const getImageUrl = (file) =>
    `${apiBaseUrl}/workorderimages/${encodeURIComponent(
      file.file_url.split(/(\\|\/)/g).pop()
    )}`;

  return (
    <div className="print-container">
      {/* Header */}
      <div className="print-header">
        <div className="print-header-left">
          <h1>Work Order #{workOrderDetails?.order_id}</h1>
          <p>Generated on {new Date().toLocaleString()}</p>
        </div>
        <div className="print-header-badge">{workOrderDetails?.status || "N/A"}</div>
      </div>

      {/* Member Information */}
      {member && (
        <div className="section-card">
          <h2>Member Information</h2>
          <div className="info-grid">
            <div className="info-item">
              <strong>Name</strong>
              {member.FirstName} {member.LastName}
            </div>
            <div className="info-item">
              <strong>Address</strong>
              {member.FullAddress || member.address || "N/A"}
            </div>
            <div className="info-item">
              <strong>Phone</strong>
              {member.PhoneNumber || member.phone || "N/A"}
            </div>
            <div className="info-item">
              <strong>Email</strong>
              {member.EmailAddress || member.email || "N/A"}
            </div>
          </div>
        </div>
      )}

      {/* Work Order Details */}
      <div className="section-card">
        <h2>Work Order Details</h2>
        <div className="info-grid">
          <div className="info-item">
            <strong>Status</strong>
            <span className="status-badge">{workOrderDetails?.status || "N/A"}</span>
          </div>
          <div className="info-item">
            <strong>Priority</strong>
            {selectedPriority || "N/A"}
          </div>
          <div className="info-item">
            <strong>Assignee</strong>
            {selectedAssignee?.name || "N/A"}
          </div>
          <div className="info-item">
            <strong>Type</strong>
            {type}
          </div>
          <div className="info-item">
            <strong>Subtype</strong>
            {subtype}
          </div>
          <div className="info-item">
            <strong>Location</strong>
            {location}
          </div>
          <div className="info-item">
            <strong>Created</strong>
            {workOrderDetails?.created_at
              ? new Date(workOrderDetails.created_at).toLocaleString()
              : "N/A"}
          </div>
          {workOrderDetails?.resolved_at && (
            <div className="info-item">
              <strong>Resolved</strong>
              {new Date(workOrderDetails.resolved_at).toLocaleString()}
            </div>
          )}
        </div>

        {workOrderDetails?.description && (
          <>
            <div style={{ marginTop: 16, fontSize: 12, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.4px", color: "#888" }}>
              Description
            </div>
            <div className="description-box">{workOrderDetails.description}</div>
          </>
        )}
      </div>

      {/* Attached Images */}
      {imageFiles.length > 0 && (
        <div className="section-card">
          <h2>Attached Images ({imageFiles.length})</h2>
          <div className="images-grid">
            {imageFiles.map((file) => (
              <img
                key={file.file_id || file.file_url}
                src={getImageUrl(file)}
                alt={file.file_name || "Attachment"}
              />
            ))}
          </div>
        </div>
      )}

      {/* Comments */}
      <div className="section-card">
        <h2>Comments ({comments.length})</h2>
        {comments.length === 0 ? (
          <p style={{ fontSize: 14, color: "#999", margin: 0 }}>No comments recorded.</p>
        ) : (
          comments.map((c) => (
            <div key={c.comment_id} className="comment-block">
              <div className="comment-header">
                <span className="comment-author">
                  {c.user_name} {c.user_lastname}
                </span>
                <span className="comment-date">
                  {new Date(c.sent_at).toLocaleString()}
                </span>
              </div>
              <p className="comment-body">{c.comment_text}</p>
            </div>
          ))
        )}
      </div>

      <div className="print-footer">
        My HOA Management System &nbsp;·&nbsp; Printed on {new Date().toLocaleString()}
      </div>
    </div>
  );
};

export default WorkOrderPrintLayout;
